<template>
   <section class="page-section" id="dev_log">
		<div class="container">
			<div class="row">
				<div class="col-lg-12 text-center">
				  <h2 class="section-heading text-uppercase">Développement logiciel</h2>
				</div>
			</div>
			
			<div class="row">
				<div class="col-lg-12">
				  <ul class="timeline">
					<li>
					  <div class="timeline-image"></div>
					  
					  <div class="timeline-panel">
						<div class="timeline-heading">
						  <h4>Analyse</h4>						 
						</div>
						
						<div class="timeline-body">
							<p class="text-muted">
							Elle recense et documente chaque fonctionnalité que devra offrir le logiciel et crée les documents de spécification explicitant de manière plus approfondie le cahier des charges défini 
							par le lcient, le plus souvent non familiarisé avec le métier du développement logiciel. Dans le cas d'une interface graphique d'un logiciel, on peut créer par la suite une maquette qui sera 
							approuvée et le plus souvent approfondie par le client ou les utilisateurs. Le cahier des charges détaillé permet au chef de projet de calculer le détail du coût de fabrication du logiciel, 
							lui-même fonction du temps estimé nécessaire.
							</p>
						</div>
					  </div>
					</li>
					
					<li class="timeline-inverted">
						<div class="timeline-image"></div>
						
						<div class="timeline-panel">
							<div class="timeline-heading">
								<h4>Conception</h4>								
							</div>
						
							<div class="timeline-body">
								<p class="text-muted">
								Le travail de conception consiste à déterminer les solutions techniques qui permettent de satisfaire le cahier des charges 
								et donc répondre aux attentes de l'usager. L'ingénieur se base sur son expérience, ainsi que sur les patrons de conception, modèles de solutions déjà 
								éprouvés. Il en résulte des diagrammes d'architecture, une description du modèle de données et le diagramme de classes, les diagrammens utilisent 
								souvent la notation UML.
								</p>
							</div>
						</div>
					</li>
					
					<li>
						<div class="timeline-image"></div>
					 
						<div class="timeline-panel">
							<div class="timeline-heading">
								<h4>Construction</h4>								
							</div>
						
							<div class="timeline-body">
								<p class="text-muted">
								La construction est la principale activité, qui occupe plus de la moitié de la durée totale du développement. Durant cette étape, le ou les programmes rédigent 
								le code source du logiciel, puis utilisent un compilateur pour le transformer et obtenir les différents composants du logiciel proprement dit. Le programmeur effectue 
								également de nombreux tests en vue de déceler le maximum de bugs, des erreurs de programmation. Des test de non-régression permettent de vérifier que l'ajout de nouvelles 
								fonctionnalités ne compromet pas les anciennes. L'un des soucis du procédé est que des tests peuvent démontrer la présence d'erreurs mais jamais leur absence. Les différents 
								modules du logiciel sont programmés un par un, puis rassemblés, et de nouveaux tests sont effectués en vue de vérifier le fonctionn de l'ensemble : test d'intégration. Le produit 
								de cette phase est livrable : l'ensemble des fichiers mis à disposition de l'utilisateur final, non seulement les programmes mais le mode d'emploi et les fichiers de configuration.
								Le livrable peut être une application informatique complète, un composant ou un patch.
								</p>
							</div>
						</div>
					</li>
					
					<li class="timeline-inverted">
						<div class="timeline-image"></div>
					 
						<div class="timeline-panel">
							<div class="timeline-heading">
								<h4>Recette</h4>								
							</div>
							
							<div class="timeline-body">
								<p class="text-muted">
								Durant la recette, divers contrôles sont effectués avant que le logiciel soit mis sur le marché. Un examen approfondi, composé d'une suite de test, est effectué en vue de vérifier l'alignement 
								du produit avec le cahier des charges. Une version bêta du logiciel est mise à disposition d'un nombre limité d'usagers en vue de leur permettre d'évaleuer l'adéquation du logiciel avec leurs attentes.
								</p>
							</div>
						</div>
					</li>					
			    </ul>
			</div>
		  </div>
		</div>
	 </section>
</template>

<script>
export default {
    
}
</script>

<style lang="css">

</style>


